import {
    SET_CURRENT_USER,
    SET_CIDS,
    USER_LOADING,
    USER_LOADED
  } from "../actions/types";
  const isEmpty = require("is-empty");
  const initialState = {
    isAuthenticated: false,
    user: {},
    cids: [],
    loading: false
  };
  export default function(state = initialState, action) {
    switch (action.type) {
      case SET_CURRENT_USER:
        return {
          ...state,
          isAuthenticated: !isEmpty(action.payload),
          user: action.payload,
        };
      case SET_CIDS:
        return {
          ...state,
          cids: action.payload,
        };
      case USER_LOADING:
        return {
          ...state,
          loading: true
        };
      case USER_LOADED:
        return {
          ...state,
          loading: false
        };
      default:
        return state;
    }
  }